import * as validators from '@vuelidate/validators';
import { trans } from 'laravel-vue-i18n';
export const required = validators.helpers.withMessage(() => trans('validation.required'), validators.required);
